import React from 'react';

import { bemBlock, Icon, IconStack, text } from '@neptune/shared/venus-ui';

import './IconWithIndicator.less';

const block = bemBlock('icon-with-indicator');

export function IconWithIndicator({
  glyph,
  showIndicator = false,
  size,
  className,
  transform = { x: 0.3, y: -0.2 },
  indicatorColor = 'info',
  indicatorSize = 'lg',
}: {
  glyph: React.ComponentProps<typeof Icon>['glyph'];
  showIndicator?: boolean;
  size?: React.ComponentProps<typeof Icon>['size'];
  className?: string;
  transform?: React.ComponentProps<typeof Icon>['transform'];
  indicatorColor?: text.Color;
  indicatorSize?: React.ComponentProps<typeof Icon>['size'];
}) {
  return (
    <IconStack className={block({ extra: className })} size={size}>
      <Icon color="text-alt" fixedWidth glyph={glyph} />
      {showIndicator && (
        <Icon
          className={block({ element: 'dot-indicator', modifiers: { color: indicatorColor } })}
          size={indicatorSize}
          transform={transform}
          glyph="dot"
          data-role="icon-indicator"
          data-indicator-color={indicatorColor}
        />
      )}
    </IconStack>
  );
}
